import {
  RUTA_ECHEQUE,
  VISTA_ECHEQUE,
  leerParam,
  rutaEcheq,
} from "./echeqMenu.constants";

export const BANDEJAS = {
  CC: "cc",
  FINANZAS: "finanzas",
  CARTERA: "cartera",
};

/**
 * Rutas de system_menu (sin slash). Authz UI = menú asignado, no user_autorizaciones.
 * Siguen asignadas para prender pestañas. El árbol muestra una sola entrada eCheq.
 */
export const MENU_CHEQUES = {
  CARTERA: "cheques_proveedores",
  CC: "cheques_cc",
  FINANZAS: "cheques_finanzas",
};

/**
 * Decisiones de PATCH /cheques/:id/revision-cc (y lote).
 * `repudiar` es la preferida; `rechazar` es alias legacy del back.
 */
export const DECISION_CC = {
  ACEPTAR: "aceptar",
  PENDIENTE: "pendiente",
  REPUDIAR: "repudiar",
  REABRIR: "reabrir",
  /** Alias legacy de REPUDIAR; el back sigue aceptándolo. */
  RECHAZAR: "rechazar",
};

export const ESTADOS_WORKFLOW = {
  PENDIENTE_CC: "pendiente_cc",
  PENDIENTE: "pendiente",
  /** CC no acepta el eCheq. */
  REPUDIADO: "repudiado",
  /** Alias legado de repudiado (filas no migradas). No confundir con RECHAZADO (bancario). */
  RECHAZADO_CC: "rechazado_cc",
  ACEPTADO: "aceptado",
  BAJA: "baja",
  DISPONIBLE: "Disponible",
  ENDOSADO: "Endosado",
  DEPOSITADO: "Depositado",
  RETENIDO: "Retenido",
  /** Cheque propio emitido en una OP. */
  EMITIDO: "Emitido",
  /** Rechazo bancario: el banco no pagó. Circuito de /cheques/:id/rechazo. */
  RECHAZADO: "Rechazado",
  /** Legados post-migración → aceptado. Se mantienen por si llega un registro viejo. */
  PROPUESTO_ACEPTACION: "propuesto_aceptacion",
  PENDIENTE_FINANZAS: "pendiente_finanzas",
};

export const LABEL_ESTADO = {
  pendiente_cc: "Pendiente CC",
  pendiente: "Pendiente",
  repudiado: "Repudiado",
  rechazado_cc: "Repudiado",
  aceptado: "Aceptado",
  baja: "Baja",
  Disponible: "Disponible",
  Endosado: "Endosado",
  Depositado: "Depositado",
  Retenido: "Retenido",
  Emitido: "Emitido",
  Rechazado: "Rechazo bancario",
  propuesto_aceptacion: "Aceptado",
  pendiente_finanzas: "Aceptado",
};

export const ESTADOS_FILTRO = [
  { value: "", label: "Todos" },
  { value: "pendiente_cc", label: LABEL_ESTADO.pendiente_cc },
  { value: "pendiente", label: LABEL_ESTADO.pendiente },
  { value: "aceptado", label: LABEL_ESTADO.aceptado },
  { value: "repudiado", label: LABEL_ESTADO.repudiado },
  { value: "rechazado_cc", label: "Repudiado (legado)" },
  { value: "baja", label: LABEL_ESTADO.baja },
  { value: "Disponible", label: LABEL_ESTADO.Disponible },
  { value: "Emitido", label: LABEL_ESTADO.Emitido },
  { value: "Endosado", label: LABEL_ESTADO.Endosado },
  { value: "Depositado", label: LABEL_ESTADO.Depositado },
  { value: "Retenido", label: LABEL_ESTADO.Retenido },
  { value: "Rechazado", label: LABEL_ESTADO.Rechazado },
];

/** Repudio de CC: estado nuevo + alias legado hasta que corra el SQL. */
export const esEstadoRepudio = (estado) => {
  const e = String(estado || "");
  return (
    e === ESTADOS_WORKFLOW.REPUDIADO || e === ESTADOS_WORKFLOW.RECHAZADO_CC
  );
};

export const LABEL_INCONSISTENCIA = {
  banco_sin_autorizacion_cc: "Banco aceptó sin autorización CC",
  cc_sin_banco: "Autorizado CC sin match banco",
  estado_banco_no_aceptado: "Estado banco no es aceptación",
};

export const labelEstado = (estado) =>
  LABEL_ESTADO[estado] || estado || "—";

export const labelInconsistencia = (tipo) =>
  LABEL_INCONSISTENCIA[tipo] || tipo || "Inconsistente";

export const colorEstado = (estado) => {
  const e = String(estado || "").toLowerCase();
  if (e === "disponible") return "success";
  if (e === "emitido") return "info";
  if (e === "aceptado" || e === "propuesto_aceptacion") return "info";
  if (e === "baja") return "default";
  if (e === "repudiado" || e === "rechazado_cc") return "error";
  if (e.includes("rechaz") || e.includes("reten")) return "error";
  if (e.includes("endos") || e.includes("deposit")) return "primary";
  if (e.includes("pendiente")) return "warning";
  return "default";
};

export const normalizarRutaMenu = (ruta) =>
  String(ruta || "")
    .trim()
    .replace(/^\/+/, "")
    .toLowerCase();

export const bandejaDesdePath = (pathname = "", search = "") => {
  const q = leerParam(search, "bandeja");
  if (q === BANDEJAS.CC || q === BANDEJAS.FINANZAS || q === BANDEJAS.CARTERA) {
    return q;
  }
  const path = String(pathname || "");
  if (path.includes("cheques_cc")) return BANDEJAS.CC;
  if (path.includes("cheques_finanzas") && !path.includes("rechazo")) {
    return BANDEJAS.FINANZAS;
  }
  if (path.includes(RUTA_ECHEQUE)) return null;
  return BANDEJAS.CARTERA;
};

export const tituloBandeja = (bandeja) => {
  if (bandeja === BANDEJAS.CC) return "Cheques — Cuentas Corrientes";
  if (bandeja === BANDEJAS.FINANZAS) return "Cheques — Finanzas";
  return "Cheques — Cartera";
};

export const rutaBandeja = (bandeja) =>
  rutaEcheq({ vista: VISTA_ECHEQUE.CHEQUES, bandeja });

/** Origen que manda el back en cada ítem de cheque (no inferir en el front). */
export const ORIGEN_CHEQUE = {
  PROPIO: "propio",
  TERCERO: "tercero",
};

export const LABEL_ORIGEN_CHEQUE = {
  propio: "Cheque propio",
  tercero: "Cheque de tercero",
};

/** Texto corto para columnas y badges. */
export const ABREV_ORIGEN_CHEQUE = {
  propio: "Propio",
  tercero: "Tercero",
};

export const ORIGEN_CHEQUE_FILTRO = [
  { value: "", label: "Todos" },
  { value: ORIGEN_CHEQUE.TERCERO, label: ABREV_ORIGEN_CHEQUE.tercero },
  { value: ORIGEN_CHEQUE.PROPIO, label: ABREV_ORIGEN_CHEQUE.propio },
];

export const origenChequeDe = (cheque) => {
  const raw = typeof cheque === "string" ? cheque : cheque?.origen_cheque;
  const k = String(raw || "")
    .trim()
    .toLowerCase();
  if (k === ORIGEN_CHEQUE.PROPIO || k === ORIGEN_CHEQUE.TERCERO) return k;
  return "";
};

/** Texto para columna/badge: origen_cheque_label del back. */
export const labelOrigenCheque = (cheque) => {
  if (cheque && typeof cheque === "object") {
    const label = String(cheque.origen_cheque_label || "").trim();
    if (label) return label;
  }
  const origen = origenChequeDe(cheque);
  return LABEL_ORIGEN_CHEQUE[origen] || "—";
};

export const abrevOrigenCheque = (cheque) => {
  const origen = origenChequeDe(cheque);
  return ABREV_ORIGEN_CHEQUE[origen] || labelOrigenCheque(cheque);
};

export const colorOrigenCheque = (cheque) => {
  const origen = origenChequeDe(cheque);
  if (origen === ORIGEN_CHEQUE.PROPIO) return "success";
  if (origen === ORIGEN_CHEQUE.TERCERO) return "primary";
  return "default";
};

/**
 * Copia origen_cheque / label / es_propio. `fallbackOrigen` solo cuando el
 * ítem aún no vino del back (alta local en OP: recibidos=tercero, emitidos=propio).
 */
export const camposOrigenCheque = (
  cheque,
  fallbackOrigen = ORIGEN_CHEQUE.TERCERO
) => {
  const origen = origenChequeDe(cheque) || fallbackOrigen;
  const labelRaw =
    cheque && typeof cheque === "object"
      ? String(cheque.origen_cheque_label || "").trim()
      : "";
  const esPropioRaw = cheque?.es_propio;
  const es_propio =
    esPropioRaw === 1 || esPropioRaw === true
      ? 1
      : esPropioRaw === 0 || esPropioRaw === false
        ? 0
        : origen === ORIGEN_CHEQUE.PROPIO
          ? 1
          : 0;
  return {
    origen_cheque: origen,
    origen_cheque_label: labelRaw || LABEL_ORIGEN_CHEQUE[origen] || "",
    es_propio,
  };
};

export const esChequePropio = (cheque) => {
  if (!cheque) return false;
  if (cheque.es_propio === 1 || cheque.es_propio === true) return true;
  return origenChequeDe(cheque) === ORIGEN_CHEQUE.PROPIO;
};

/** Query de detalle: el id de un propio puede coincidir con un tercero. */
export const queryOrigenCheque = (cheque) =>
  origenChequeDe(cheque) || undefined;

/** Clave de fila: id puede repetirse entre propio y tercero. */
export const idFilaCheque = (cheque, idOverride) => {
  const id = idOverride ?? cheque?.id ?? "";
  const origen = origenChequeDe(cheque) || ORIGEN_CHEQUE.TERCERO;
  return `${origen}-${id}`;
};
